import { FEATURES } from "../models/Plan";
import {
    ALLOW_OUT_OF_STOCK_EXCHANGE_OPTION,
    REFUND_BY,
    RESOLUTION_ID,
    RESOLUTION_TYPE
} from '../pages/resolutions/constants';

export enum PLATFORM_DISPLAY_NAME {
    MAGENTO = "Magento2",
    SHOPIFY = "Shopify",
    BIGCOMMERCE = "Bigcommerce",
    CUSTOM = "E-Commerce Platform",
    SALESFORCE = "Salesforce",
    WIX = "Wix",
    NONE = '',
}

class PlatformServiceStore {
    constructor(private _model?: IPlatform) { }

    public isFunctionalitySupported(funcId: FUNC): boolean {
        return this._model?.not_supported_functionality.indexOf(funcId) === -1;
    }

    public isFeatureSupported(feature: FEATURES): boolean {
        return this._model?.not_supported_features.indexOf(feature) === -1;
    }

    public isRefundMethodSupportedByValue(refundMethodValue: REFUND_BY): boolean {
        return this._model?.not_supported_refund_methods_values.indexOf(refundMethodValue) === -1;
    }

    public isResolutionSupportedByType(resolutionType: RESOLUTION_TYPE): boolean {
        return this._model?.not_supported_resolution_types.indexOf(resolutionType) === -1;
    }

    public isResolutionSupportedById(resolutionId: RESOLUTION_ID): boolean {
        return this._model?.not_supported_resolution_ids.indexOf(resolutionId) === -1;
    }

    public getPlatformDisplayName(): PLATFORM_DISPLAY_NAME {
        return this._model?.platform_name ?? PLATFORM_DISPLAY_NAME.NONE;
    }

    public isShopify(): boolean {
        return this._model?.platform_name === 'Shopify';
    }
}

export default PlatformServiceStore;

export interface IPlatform {
    not_supported_functionality: FUNC[],
    not_supported_features: FEATURES[],
    not_supported_refund_methods_values: REFUND_BY[],
    not_supported_resolution_types: RESOLUTION_TYPE[],
    not_supported_resolution_ids: RESOLUTION_ID[],
    not_supported_allow_out_of_stock_exchange_options: ALLOW_OUT_OF_STOCK_EXCHANGE_OPTION[],
    platform_name: PLATFORM_DISPLAY_NAME,
}

export enum FUNC {
    FUNC_ADD_ORDER_NOTES = 0,
    FUNC_CONTEXTUAL_PRICING = 1,
    FUNC_SEND_PLATFORM_EMAIL = 2,
    FUNC_SET_ADMIN_PATH = 3,
    FUNC_SETTING_LABEL_FEE_PAYMENT = 4,
    FUNC_SETTING_GIFT_RETURNS = 8,
    FUNC_INVENTORY_BASED_ON_ONLINE_LOCATIONS = 9, // On shopify we retrieve inventory information only from locations that fulfills online orders but not all platforms have that functionality
    FUNC_EXCHANGE_TO_HIGHER = 10,
    FUNC_ADD_ORDER_TAGS = 11,
    FUNC_VALIDATE_API_SCOPES = 12,
    FUNC_ANALYTICS_ORDERS = 13,
    FUNC_ORDER_STATUS_URL = 14,
    FUNC_CHARGE_TAXES_FOR_FEES = 15,
    FUNC_LINE_ITEM_DISCOUNT_FOR_DRAFT_ORDER = 16,
    FUNC_ALLOW_PARTIAL_OUT_OF_STOCK = 18,
    FUNC_DRAFT_ORDER_SHIPPING_RATES = 27,
}
